import Option from './Option';

export default Option;


// WEBPACK FOOTER //
// ./src/components/Others/CustomerSelect/components/Option/index.tsx